/* eslint-disable no-console */

import { register } from "register-service-worker";

const APP_VERSION = process.env.VUE_APP_VERSION || "dev";

console.log(`App version: ${APP_VERSION}`);
console.log("Registering service worker...");

register(`${process.env.BASE_URL}service-worker.js`, {
  ready(registration) {
    console.log(
      `App v${APP_VERSION} is being served from cache by a service worker.`
    );
  },
  registered(registration) {
    console.log(`Service worker registered for app v${APP_VERSION}`);

    // Check for updates periodically (every 5 minutes)
    setInterval(() => {
      registration.update();
    }, 5 * 60 * 1000);
  },
  cached() {
    console.log("Content has been cached for offline use.");
  },
  updatefound() {
    console.log("New app version is downloading...");
  },
  updated(registration) {
    console.log(`New app version available! Updating to v${APP_VERSION}...`);

    // Dispatch event so UI can show update notification
    document.dispatchEvent(
      new CustomEvent("swUpdated", { detail: registration })
    );

    // Auto-reload after a short delay
    if (process.env.NODE_ENV === "production") {
      setTimeout(() => {
        window.location.reload(true);
      }, 2000);
    }
  },
  offline() {
    console.log(
      "No internet connection found. App is running in offline mode."
    );
  },
  error(error) {
    console.error("Error during service worker registration:", error);
  }
});
